<template>
<div>
  <va-card :class="{'closed': !expanded}">
    <template slot="header">
      <div class="d-flex align-items-center justify-content-between w-100">
        <h5 class="card-title">{{ $t('accounts.test_sessions') }}</h5>
        <span v-if="expandable" @click.prevent="expanded = !expanded">
            <va-icon class="clickable" :name="expandIconClass" color="success"/>
          </span>
      </div>
    </template>

    <div v-show="expanded">
      <v-server-table
        :columns="tableColumns"
        :options="tableOptions"
        ref="tesSessionsTable"
        @row-click="selectSessionDetails">
        <span slot="createdAt" class="no-break" slot-scope="{row}">{{ row.createdAt | localTime }}</span>

        <span slot="finishedSubtests" class="no-break" slot-scope="{row}">
          {{
            row.finishedSubtests.map(elem => $t(`audiology_4_all.titles.tests.${elem.subtest.slug}`)).join(', ')
          }}
        </span>

        <span slot="isSessionFinished" class="no-break" slot-scope="{row}" style="text-align: center !important;">
          <i class="fa fa-check" v-if="row.finishedAt"/>
        </span>

      </v-server-table>

      <A4ATestSessionDetailsModal
        v-if="selectedSessionDetails !== null"
        :account="account"
        :testSession="selectedSessionDetails"
        @closeModal="selectedSessionDetails = null"
      />
    </div>
  </va-card>
</div>
</template>

<script>
import TableQueryMixin from "@/mixins/TableQueryMixin.vue";
import Vue from "vue";
import A4ATestSessionDetailsModal
  from "@/components/clinical/accounts/AccountDetails/A4A/A4ATestSessionDetailsModal.vue";

export default {
  components: {A4ATestSessionDetailsModal},
  props: {
    account: {
      type: Object,
      required: true
    },
    expandable: {
      type: Boolean,
      required: false,
      default: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  mixins: [
    TableQueryMixin
  ],
  data: function () {
    return {
      isOpen: false,
      expanded: true,
      selectedSessionDetails: null,
      tableColumns: [
        'createdAt',
        'finishedSubtests',
        'isSessionFinished'
      ],
      tableOptions: {
        filterable: false,
        sortable: ['createdAt'],
        headings: {
          createdAt: this.$t('audiology_4_all.titles.columnTitles.createdAt'),
          finishedSubtests: this.$t('audiology_4_all.titles.columnTitles.finishedSubtests'),
          isSessionFinished: this.$t('audiology_4_all.titles.columnTitles.isSessionFinished')
        },
        columnsDropdown: false
      },
    }
  },
  computed: {
    expandIconClass: function () {
      return this.expanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
    },
    queryUrl: function () {
      return `${this.a4aServiceUrl}/v1/test_session/admin/users/${this.account.id}/all`
    },
    a4aServiceUrl: function () {
      return this.$store.state.a4a_server
    }
  },
  methods: {
    selectSessionDetails: function ({row}) {
      Vue.nextTick(() => {
        this.selectedSessionDetails = row
      })
    }
  }
}
</script>

<style scoped>

</style>
